export function buildIncludeTestOrdersQueryParam(
  includeTestOrders = false,
): string {
  return includeTestOrders ? "&includeTestOrders=true" : "";
}

export const LPN_SEARCH_MAX_LENGTH = 10;

export function sanitizeLpnSearchQuery(value: string | undefined): string {
  return (value ?? "")
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "")
    .slice(0, LPN_SEARCH_MAX_LENGTH);
}

/** Omitted when the box is empty. The server treats the value as an ends-with match. */
export function buildLpnSearchQueryParam(lpn: string | undefined): string {
  const query = sanitizeLpnSearchQuery(lpn);
  if (!query) return "";
  return `&licensePlateNumber=${encodeURIComponent(query)}`;
}

export function shouldIncludeTestOrdersFromFilter(filterObject: {
  includeTestOrders?: boolean;
  testOrderStatus?: string;
}): boolean {
  return (
    filterObject.includeTestOrders === true ||
    filterObject.testOrderStatus === "TEST"
  );
}